import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class SandblastMobileIcon extends BaseIcon {
  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#ff9e0e' : this.getColor()
    return [
      <g>
        <path fill={ color }
              d="M34.24,16.25c-1-1-2.44-.44-3.42-1.42s-.44-2.44-1.42-3.41S27,11,26,10s-.26-2.48-1.31-3.53S22.2,6.2,21.15,5.16,20.8,2.7,19.79,1.69A2.86,2.86,0,0,0,18,1H4A3,3,0,0,0,1,4V32a3,3,0,0,0,3,3H32a3,3,0,0,0,3-3V18.24A3.5,3.5,0,0,0,34.24,16.25Z"/>
        <circle fill={ color } cx="28.1" cy="7.9" r="1.5"/>
        <path
          fill={ '#fff' }
          d="M23,7.9H13a2,2,0,0,0-2,2V26.2a1.63,1.63,0,0,0,.07.5A2,2,0,0,1,13,25.21V9.89H23V26.21H13a1,1,0,1,0,0,2H23a2,2,0,0,0,2-2V9.9A2,2,0,0,0,23,7.9Z"/>
        <circle fill={ color } cx="33" cy="7.9" r="1"/>
        <circle fill={ color } cx="33" cy="12.7" r="1.5"/>
        <circle fill={ color } cx="32.9" cy="3.1" r="0.5"/>
        <circle fill={ color } cx="28.1" cy="3.1" r="1"/>
        <circle fill={ color } cx="23.3" cy="3.1" r="1.5"/>
        <path fill={ '#fff' } fillRule={ 'evenodd' } d="M15,9.9a.49.49,0,0,1,.49.49.5.5,0,0,0,.5.5h4.07a.5.5,0,0,0,.5-.5.49.49,0,0,1,.49-.49Z"/>
      </g>,
      <g >
        <path fill={ color }
              d="M34.24,16.25c-1-1-2.44-.44-3.42-1.42s-.44-2.44-1.42-3.41S27,11,26,10s-.26-2.48-1.31-3.53S22.2,6.2,21.15,5.16,20.8,2.7,19.79,1.69A2.86,2.86,0,0,0,18,1H4A3,3,0,0,0,1,4V32a3,3,0,0,0,3,3H32a3,3,0,0,0,3-3V18.24A3.5,3.5,0,0,0,34.24,16.25Z"/>
        <circle fill={ color } cx="28.1" cy="7.9" r="1.5"/>
        <path fill={ '#fff' }
              d="M23,7.9H13a2,2,0,0,0-2,2V26.2a1.63,1.63,0,0,0,.07.5A2,2,0,0,1,13,25.21V9.89H23V26.21H13a1,1,0,1,0,0,2H23a2,2,0,0,0,2-2V9.9A2,2,0,0,0,23,7.9Z"/>
        <circle fill={ color } cx="33" cy="7.9" r="1"/>
        <circle fill={ color } cx="33" cy="12.7" r="1.5"/>
        <circle fill={ color } cx="32.9" cy="3.1" r="0.5"/>
        <circle fill={ color } cx="28.1" cy="3.1" r="1"/>
        <circle fill={ color } cx="23.3" cy="3.1" r="1.5"/>
        <path fill={ '#fff' } fillRule={ 'evenodd' }d="M15,9.9a.49.49,0,0,1,.49.49.5.5,0,0,0,.5.5h4.07a.5.5,0,0,0,.5-.5.49.49,0,0,1,.49-.49Z"/>
      </g>

    ]
  }
  getViewBox = () => '0 0 36 36'
}
